module.exports = __webpack_public_path__ + "img/handcare_handcream_202312.24c4ab34.jpg";